export const MultiLineTextCell = ({ value }: { value?: string }) => {
  const text = value?.trim();
  if (!text) return null;

  return <div className="truncate">{text}</div>;
};
